import React from 'react';
import { styled } from '@ff/ui';
import SkeletonLoader from '@ff/ui/Skeleton/SkeletonLoader';

export default function DescriptiveGalleryLoader() {
  return (
    <Container>
      <InnerContainer>
        <TextLoader>
          <SkeletonLoader variant="text" />
          <SkeletonLoader variant="text" />
          <SkeletonLoader variant="text" />
          <SkeletonLoader variant="text" />
        </TextLoader>
        <ImageLoader>
          <SkeletonLoader variant="rectangular" height="100%" width="100%" />
        </ImageLoader>
      </InnerContainer>
      <DotsLoader>
        <SkeletonLoader variant="circular" height={10} width={10} />
        <SkeletonLoader variant="circular" height={10} width={10} />
        <SkeletonLoader variant="circular" height={10} width={10} />
        <SkeletonLoader variant="circular" height={10} width={10} />
        <SkeletonLoader variant="circular" height={10} width={10} />
      </DotsLoader>
    </Container>
  );
}

const Container = styled.Box(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  padding: '36px 36px 72px 36px',
  height: '470px',
  [theme.mediaQueries.md]: {
    height: '640px'
  }
}));

const InnerContainer = styled.Box(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%',
  maxWidth: '1596px',
  height: '346px',
  margin: 'auto',
  [theme.mediaQueries.minWidth('576px')]: {
    display: 'flex'
  },
  [theme.mediaQueries.sm]: {
    height: '190px'
  },
  [theme.mediaQueries.md]: {
    height: '298px'
  },
  [theme.mediaQueries.lg]: {
    height: '406px'
  }
}));

const TextLoader = styled.Box(({ theme }) => ({
  width: '100%',
  [theme.mediaQueries.minWidth('576px')]: {
    width: '36%',
    paddingRight: '36px',
  },
  margin: '18px 0px 36px'
}));

const ImageLoader = styled.Box(({ theme }) => ({width: '100%',
  [theme.mediaQueries.minWidth('576px')]: {
    width: '64%',
  },
  height: '192px',
  [theme.mediaQueries.sm]: {
    height: '100%'
  }
}));

const DotsLoader = styled.Box({
  width: '100%',
  bottom: '25px',
  marginTop: '30px',
  display: 'flex',
  justifyContent: 'center',
  height: 10,
  '& span': {
    marginLeft: '5px',
  },
});
